import classNames from 'classnames';

export function getDeltaTextClassNames(delta: number): classNames.Argument {
  if (typeof delta !== 'number') {
    return {};
  }

  return {
    'yst-text-green-600': delta > 0,
    'yst-text-red-600': delta < 0,
    'yst-text-gray-400': delta === 0,
  };
}
